var map = {
	".": 77,
	"./": 77,
	"./Icons/Amazon": 647,
	"./Icons/Amazon.js": 647,
	"./Icons/Amex": 648,
	"./Icons/Amex.js": 648,
	"./Icons/Applepay": 649,
	"./Icons/Applepay.js": 649,
	"./Icons/Aura": 650,
	"./Icons/Aura.js": 650,
	"./Icons/Bb": 651,
	"./Icons/Bb.js": 651,
	"./Icons/Bitcoin": 652,
	"./Icons/Bitcoin.js": 652,
	"./Icons/Boleto": 653,
	"./Icons/Boleto.js": 653,
	"./Icons/Bradesco": 654,
	"./Icons/Bradesco.js": 654,
	"./Icons/Caixa": 655,
	"./Icons/Caixa.js": 655,
	"./Icons/Cielo": 656,
	"./Icons/Cielo.js": 656,
	"./Icons/Cirrus": 657,
	"./Icons/Cirrus.js": 657,
	"./Icons/Diners": 658,
	"./Icons/Diners.js": 658,
	"./Icons/DirectDebit": 659,
	"./Icons/DirectDebit.js": 659,
	"./Icons/Discover": 660,
	"./Icons/Discover.js": 660,
	"./Icons/Ebay": 661,
	"./Icons/Ebay.js": 661,
	"./Icons/Elavon": 662,
	"./Icons/Elavon.js": 662,
	"./Icons/Elo": 663,
	"./Icons/Elo.js": 663,
	"./Icons/Eway": 664,
	"./Icons/Eway.js": 664,
	"./Icons/Generic": 665,
	"./Icons/Generic.js": 665,
	"./Icons/Global": 666,
	"./Icons/Global.js": 666,
	"./Icons/Googlepay": 667,
	"./Icons/Googlepay.js": 667,
	"./Icons/Hsbc": 668,
	"./Icons/Hsbc.js": 668,
	"./Icons/Itau": 669,
	"./Icons/Itau.js": 669,
	"./Icons/Jcb": 670,
	"./Icons/Jcb.js": 670,
	"./Icons/Maestro": 671,
	"./Icons/Maestro.js": 671,
	"./Icons/Mastercard": 672,
	"./Icons/Mastercard.js": 672,
	"./Icons/Pagseguro": 673,
	"./Icons/Pagseguro.js": 673,
	"./Icons/Paypal": 674,
	"./Icons/Paypal.js": 674,
	"./Icons/Rede": 675,
	"./Icons/Rede.js": 675,
	"./Icons/Sage": 676,
	"./Icons/Sage.js": 676,
	"./Icons/Santander": 677,
	"./Icons/Santander.js": 677,
	"./Icons/Shopify": 678,
	"./Icons/Shopify.js": 678,
	"./Icons/Skrill": 679,
	"./Icons/Skrill.js": 679,
	"./Icons/SkrillMoneybookers": 680,
	"./Icons/SkrillMoneybookers.js": 680,
	"./Icons/Solo": 681,
	"./Icons/Solo.js": 681,
	"./Icons/Stone": 682,
	"./Icons/Stone.js": 682,
	"./Icons/Visa": 683,
	"./Icons/Visa.js": 683,
	"./Icons/VisaElectron": 684,
	"./Icons/VisaElectron.js": 684,
	"./Icons/Wallet": 685,
	"./Icons/Wallet.js": 685,
	"./Icons/Western": 686,
	"./Icons/Western.js": 686,
	"./Icons/Worldpay": 687,
	"./Icons/Worldpay.js": 687,
	"./Icons/transparent/AmazonTransparent": 688,
	"./Icons/transparent/AmazonTransparent.js": 688,
	"./Icons/transparent/BbTransparent": 689,
	"./Icons/transparent/BbTransparent.js": 689,
	"./Icons/transparent/BoletoTransparent": 690,
	"./Icons/transparent/BoletoTransparent.js": 690,
	"./Icons/transparent/BradescoTransparent": 691,
	"./Icons/transparent/BradescoTransparent.js": 691,
	"./Icons/transparent/CaixaTransparent": 692,
	"./Icons/transparent/CaixaTransparent.js": 692,
	"./Icons/transparent/CieloTransparent": 693,
	"./Icons/transparent/CieloTransparent.js": 693,
	"./Icons/transparent/ElavonTransparent": 694,
	"./Icons/transparent/ElavonTransparent.js": 694,
	"./Icons/transparent/GenericTransparent": 695,
	"./Icons/transparent/GenericTransparent.js": 695,
	"./Icons/transparent/GlobalTransparent": 696,
	"./Icons/transparent/GlobalTransparent.js": 696,
	"./Icons/transparent/HsbcTransparent": 697,
	"./Icons/transparent/HsbcTransparent.js": 697,
	"./Icons/transparent/ItauTransparent": 698,
	"./Icons/transparent/ItauTransparent.js": 698,
	"./Icons/transparent/PagseguroTransparent": 699,
	"./Icons/transparent/PagseguroTransparent.js": 699,
	"./Icons/transparent/PaypalTransparent": 700,
	"./Icons/transparent/PaypalTransparent.js": 700,
	"./Icons/transparent/RedeTransparent": 701,
	"./Icons/transparent/RedeTransparent.js": 701,
	"./Icons/transparent/SantanderTransparent": 702,
	"./Icons/transparent/SantanderTransparent.js": 702,
	"./Icons/transparent/StoneTransparent": 703,
	"./Icons/transparent/StoneTransparent.js": 703,
	"./Icons/transparent/WalletTransparent": 704,
	"./Icons/transparent/WalletTransparent.js": 704,
	"./Icons/transparent/WorldpayTransparent": 705,
	"./Icons/transparent/WorldpayTransparent.js": 705,
	"./index": 77,
	"./index.js": 77,
	"./remoteImages": 524,
	"./remoteImages.js": 524,
	"./test": 706,
	"./test.js": 706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1133;